export const rootPath = '/AssetView';
export const path = `${rootPath}/:zoom?/:lat?/:lon?/:groupName?/:assetType?/:assetId?`;
